import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class SortingSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isExpanded: false,
        };
        this.contentRef = React.createRef();
    }

    toggleVisibility = () => {
        this.setState(
            { isExpanded: !this.state.isExpanded },
            () => {
                if (this.state.isExpanded) {
                    this.contentRef.current.focus();
                }
            }
        );
    };

    onClickBtn = (sortType) => {
        this.setState({ isExpanded: false });
        this.props.onSelect(sortType);
    };

    render() {
        const { sortTypes, selectedSortType } = this.props;
        const { isExpanded } = this.state;
        const stateCss = classNames({
            'is-expanded': isExpanded
        });

        return (
            <div className={`sorting-selector ${stateCss}`}>
                <button
                    className="sorting-selector__trigger"
                    onClick={this.toggleVisibility}
                    aria-label="toggle sorting list visibility"
                >{selectedSortType.title}
                    <svg aria-hidden="true" className="sorting-selector__trigger-icon" width="12" height="8">
                        <use xlinkHref="#icon-down"></use>
                    </svg></button>
                <ul className="sorting-selector__content" ref={this.contentRef} tabIndex={0}>
                    {
                        sortTypes.map((sortType) => {
                            const btnStateCss = classNames({
                                'is-active': sortType.id === selectedSortType.id
                            });

                            return (
                                <li className="sorting-selector__li" key={sortType.id}>
                                    <button
                                        className={`sorting-selector__btn ${btnStateCss}`}
                                        type="button"
                                        onClick={() => this.onClickBtn(sortType)}
                                        disabled={sortType.id === selectedSortType.id}
                                        aria-label={`sort by ${sortType.title}`}
                                    >{sortType.title}</button>
                                </li>
                            );
                        })
                    }
                </ul>
            </div>
        );
    }
}

SortingSelector.defaultProps = {
    onSelect: () => {},
};

SortingSelector.propTypes = {
    sortTypes: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            title: PropTypes.string,
        })
    ),
    selectedSortType: PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
    }),
    onSelect: PropTypes.func,
};

export default SortingSelector;
